/**
 * Formats a number with grouping separators.
 * Negative values render in parentheses, e.g. (20).
 */
export function formatAbsoluteNumber(value: number | null | undefined, nullishValue = ''): string {
  if (value === undefined || value === null) {
    return nullishValue;
  }

  const absoluteValue = Math.abs(value);
  const formattedValue = absoluteValue.toLocaleString('en-US');

  if (Math.sign(value) === -1) {
    return `(${formattedValue})`;
  }

  return formattedValue;
}

/**
 * Formats a currency value. Negative values render in parentheses, e.g. (£55.00).
 */
export function formatCurrency(value: number | null | undefined, currencyCode = 'GBP', nullishValue = ''): string {
  if (value === undefined || value === null) {
    return nullishValue;
  }

  const absoluteValue = Math.abs(value);
  const currencyString = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currencyCode,
  }).format(absoluteValue);

  if (Math.sign(value) === -1) {
    return `(${currencyString})`;
  }

  return currencyString;
}

/**
 * Formats a 0–100 percentage value, e.g. 72 → "72%".
 */
export function formatPercent(value: number | null | undefined, nullishValue = ''): string {
  if (value === undefined || value === null || !Number.isFinite(value)) {
    return nullishValue;
  }

  return `${Math.round(value)}%`;
}

/**
 * Formats feed sales. Missing values render as N/A.
 */
export function formatFeedSales(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return 'N/A';
  }

  return formatAbsoluteNumber(value);
}
